// SOD Redesign: de configurator-knop (blocks/sod-configurator-knop.liquid) volgt de
// gekozen kleur op de productpagina. Zelfde mechanisme als het prijsblok
// (assets/product-price.js): bij het productSelect-event van het thema komt de
// opnieuw gerenderde sectie (?variant=) mee; daaruit nemen we onze eigen link
// over, zodat ?opstelling= de nieuwe kleur bevat. Geen eigen fetch, geen state.
//
// Sticky koopbalk: het blok levert een <template> met een kopie van de knop; die
// zetten we links naast de winkelwagenknop in de balk (sections/product-information
// .liquid). De balk wordt bij een kleurwissel door het thema gemorpht naar de
// server-HTML (waar onze kopie niet in zit) en gooit de kopie dus weg; een
// MutationObserver zet hem terug, met de dan geldende link.
import { StandardEvents } from '@shopify/events';

class SodConfiguratorKnop extends HTMLElement {
  #scope = null;
  #sticky = null;
  #stickyBar = null;
  #observer = null;

  connectedCallback() {
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener(StandardEvents.productSelect, this.#onSelect);
    this.#plaatsSticky();
  }

  disconnectedCallback() {
    this.#scope?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
    this.#scope = null;
    this.#observer?.disconnect();
    this.#observer = null;
    this.#sticky?.remove();
    this.#sticky = null;
    this.#stickyBar = null;
  }

  get #link() {
    return this.querySelector(':scope > a');
  }

  #plaatsSticky() {
    const tpl = this.querySelector('template.sod-configurator-knop__sticky');
    if (!tpl || this.closest('dialog')) return;
    const bar = this.#scope?.querySelector('sticky-add-to-cart [ref="stickyBar"]');
    if (!bar) return;
    this.#stickyBar = bar;
    this.#sticky = tpl.content.firstElementChild?.cloneNode(true) ?? null;
    if (!this.#sticky) return;
    this.#zetSticky();
    this.#observer = new MutationObserver(() => {
      if (this.#sticky && !this.#stickyBar.contains(this.#sticky)) this.#zetSticky();
    });
    this.#observer.observe(bar, { childList: true });
  }

  #zetSticky() {
    if (!this.#sticky || !this.#stickyBar) return;
    const href = this.#link?.getAttribute('href');
    if (href) this.#sticky.setAttribute('href', href);
    const knop = this.#stickyBar.querySelector('[ref="addToCartButton"]');
    if (knop) knop.before(this.#sticky);
    else this.#stickyBar.append(this.#sticky);
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document, productId?: string } }> }} event */
  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    if (!event.promise) return;
    event.promise
      .then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;
        if (detail.productId && this.dataset.productId && detail.productId !== this.dataset.productId) return;
        const nieuw = html.querySelector(`sod-configurator-knop[data-block-id="${this.dataset.blockId}"] a[href]`);
        const link = this.#link;
        if (!nieuw || !link) return;
        const href = nieuw.getAttribute('href');
        if (!href) return;
        link.setAttribute('href', href);
        this.#sticky?.setAttribute('href', href);
      })
      .catch(() => {});
  };
}

if (!customElements.get('sod-configurator-knop')) {
  customElements.define('sod-configurator-knop', SodConfiguratorKnop);
}
